module.exports = __webpack_public_path__ + "img/11.627db00e.jpg";